import Actions, { useDispatch } from 'Flux/index.js'
import { useGetAllOrders, useGetAuthenticatedUser } from 'Flux/Selector/index.js'
import { selectProjects } from 'Flux/Selector/Project/ProjectSelectors.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { ProjectSort } from 'Model/Project/ProjectSort.js'
import { canUseProjects } from 'Model/index.js'
import { latestNewsArticle } from 'Model/News/newsArticles.js'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { CreateOrderLinksWidget } from './Dashboard/CreateOrderLinksWidget.tsx'
import { LatestNewsWidget } from './Dashboard/LatestNewsWidget.tsx'
import { getRecentOrders } from './Dashboard/dashboardUtils.ts'
import { OrganizationOverviewWidget } from './Dashboard/OrganizationOverviewWidget.tsx'
import { RecentOrdersWidget } from './Dashboard/RecentOrdersWidget.tsx'
import { RecentProjectsWidget } from './Dashboard/RecentProjectsWidget.tsx'
import { SubscriptionWidget } from './Dashboard/SubscriptionWidget.tsx'

export const HomeDashboardPage = () => {
  const dispatch = useDispatch()
  const user = useGetAuthenticatedUser()
  const { orders } = useGetAllOrders()
  const projects = useSelector(selectProjects)

  useEffect(() => {
    dispatch(
      Actions[orderSlice.name].getAllOrderRequest({
        size: 5,
        page: 0,
        filters: []
      })
    )
  }, [dispatch])

  useEffect(() => {
    if (!canUseProjects(user)) {
      return
    }

    dispatch(
      Actions[projectSlice.name].getAllProjectsRequest({
        size: 5,
        page: 0,
        // "Recent projects" on the dashboard means recently touched, not recently created.
        sort: ProjectSort.LAST_CHANGED,
        filters: []
      })
    )
  }, [dispatch, user])

  const recentOrders = useMemo(() => getRecentOrders(orders), [orders])

  const recentProjects = useMemo(() => {
    if (projects === 'LOADING') return 'LOADING'
    return projects.slice(0, 5)
  }, [projects])

  if (!user) return <div>Unauthorized</div>

  const projectsAccess = canUseProjects(user)

  return (
    <div className="w-full max-w-[110rem]">
      <div className="mb-8 border-b border-slate-200 pb-5">
        <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-primary">Dashboard</p>
        <h1 className="text-3xl font-bold text-slate-900">{user.org.name}</h1>
      </div>

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
        {latestNewsArticle && <LatestNewsWidget article={latestNewsArticle} />}
        <OrganizationOverviewWidget user={user} />
        <CreateOrderLinksWidget />
        <SubscriptionWidget user={user} />
        <RecentOrdersWidget recentOrders={recentOrders} />
        {projectsAccess && <RecentProjectsWidget recentProjects={recentProjects} />}
      </div>
    </div>
  )
}
